import { imageExtension } from '@copera/tiptap/extensions';
import { Editor } from '@tiptap/core';
import { Plugin, PluginKey } from '@tiptap/pm/state';
import { getExtensionOption } from '../../private/utils/getExtensionOption';

const pluginKey = new PluginKey('chatImageUpload');

export async function startChatUpload(editor: Editor, file: File) {
  const chatUploadFile = getExtensionOption(editor, 'chatUploadFile');
  if (!chatUploadFile) return;
  chatUploadFile(file);
}

export const createChatUploadPlugin = ({
  editor,
  accept,
}: {
  editor: Editor;
  accept: (files: File[]) => File[];
}) =>
  new Plugin({
    key: pluginKey,
    props: {
      handlePaste: (_view, event) => {
        if (!event.clipboardData?.files?.[0]) return false;
        const [file] = accept(Array.from(event.clipboardData.files));
        if (!file) return false;
        startChatUpload(editor, file);
        return true;
      },
    },
  });

export const chatImagePasteExtension = imageExtension.extend({
  addProseMirrorPlugins() {
    return [
      createChatUploadPlugin({
        editor: this.editor,
        accept: (files: File[]) =>
          files.filter((file) => {
            if (file.size / 1024 / 1024 > 20) {
              console.error('File size too big (max 20MB).');
              return false;
            }
            return true;
          }),
      }),
    ];
  },
});
